export default function sw()
{
    let swUrl=  `${process.env.REACT_APP_URL}serviceworker.js`
    navigator.serviceWorker.register(swUrl).then((response)=>{
        console.log("response",response)
    }) 
}